<template lang="pug">
    .sections
        section(v-for="(section, index) in sections" :key="section.id" :class="section.key" v-if="index === 0")
            Banners(v-if="section.key === 'banners'" :section="section")
            Slider(v-if="section.key === 'slider'" :section="section")
</template>
<script>
//import Components
import Banners from '@/components/Banners'
import Slider from '@/components/Slider';

export default {
    name: 'HeaderArea',
    components: {
        Banners,
        Slider
    },
    props: {
        sections: {
            type: [Array, Object],
            required: true
        }
    }
};
</script>
<style lang="sass" scoped></style>
